import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useConciergeCheck } from "../IsConcierge";

interface ConciergeRouteProps {
    children: React.ReactNode;
}

const ConciergeRoute: React.FC<ConciergeRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const conciergeCheck = useConciergeCheck();
    const [isConcierge, setIsConcierge] = useState<boolean | null>(null);

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect();
        }
    }, [isLoading, isAuthenticated, loginWithRedirect]);

    useEffect(() => {
        const checkUserIsConcierge = async () => {
            try {
                const result = await conciergeCheck;
                setIsConcierge(result);
            } catch (err) {
                console.error("Error checking concierge role", err);
                setIsConcierge(false);
            }
        };
        checkUserIsConcierge();
    }, [conciergeCheck]);

    if (isLoading || isConcierge === null) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div className="bg-white rounded-xl shadow-lg p-8">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                </div>
            </div>
        );
    }

    if (!isConcierge) {
        return <Navigate to="/" replace />;
    }

    return conciergeCheck ? <>{children}</> : <Navigate to="/" replace />;
};

export default ConciergeRoute;
